export const normalizeSubdomain = (subdomain: string): string =>
  subdomain
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[_\s]/g, '')
    .replace(/[^a-z0-9-]/g, '');
